import { LOCAL_STORAGE_KEYS } from 'common/constants/constants';
import BrowserStorageAccessor from 'common/utils/BrowserStorageAccessor';
import RegistrationLayout from 'layouts/RegistrationLayout';
import RegisterContent from 'views/RegisterV2/RegisterContent';

export type License = 'team' | 'trial' | 'paid';
/**
 * Sign-up page component
 */
export const RegisterV2 = () => {
  const license = BrowserStorageAccessor().local.get(
    LOCAL_STORAGE_KEYS.LICENSE
  ) as License;

  return (
    <RegistrationLayout>
      <RegisterContent license={license} />
    </RegistrationLayout>
  );
};
